import { createSlice } from '@reduxjs/toolkit';
import { setIntercomReady } from '../actions';

export interface IntercomState {
  isIntercomInitialized: boolean;
}

const initialState: IntercomState = {
  isIntercomInitialized: false,
};

const intercomSlice = createSlice({
  name: 'intercom',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setIntercomReady, (state) => {
      state.isIntercomInitialized = true;
    });
  },
});

export const intercomReducer = intercomSlice.reducer;
